var React = require('react');

function AirDisplay (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"air_display"),React.createElement("path",{"d":"M86.75,49.11a1.4,1.4,0,0,0-1.4,1.4v4.54l-31.21-20V21.57S53.71,7.46,44.07,0C34.44,7.46,34,21.57,34,21.57V35.06l-31.21,20V50.51a1.4,1.4,0,0,0-2.79,0V73.15a1.4,1.4,0,1,0,2.79,0V71l29.65-3L19.71,82.4v8.92L44.07,78.77,68.44,91.32V82.4L55.7,68l29.65,3v2.11a1.4,1.4,0,1,0,2.79,0V50.51A1.4,1.4,0,0,0,86.75,49.11Z","key":1}),React.createElement("path",{"d":"M44.07,80.24l-6.42,3.31v1a1.6,1.6,0,0,0,1.6,1.6H48.9a1.6,1.6,0,0,0,1.6-1.6v-1Z","key":2}),React.createElement("path",{"d":"M19.71,42.84V36.51a1.93,1.93,0,1,0-3.86,0v8.8Z","key":3}),React.createElement("path",{"d":"M72.3,45.31V37.68a1.93,1.93,0,0,0-3.86,0v5.16Z","key":4})]);
}

AirDisplay.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 88.15 91.32"};

module.exports = AirDisplay;

AirDisplay.default = AirDisplay;



//////////////////
// WEBPACK FOOTER
// ../assets/icons/air_display.svg
// module id = 916
// module chunks = 9